import { MarketplaceGeneralSettingsResponse } from 'APIs/marketplaces/marketplaces.general.settings.types';
import { supportedCustomerTypes } from 'Constants/Constants';
import React from 'react';

import { DataLabel, GeneralSettingsView, MultiColRow } from './styles';

type Props = {
  generalSettings: MarketplaceGeneralSettingsResponse | null;
};

const MarketplaceGeneralSettingsView = ({ generalSettings }: Props) => {
  return (
    <>
      {generalSettings && (
        <GeneralSettingsView>
          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Supported customer types</DataLabel>
              <DataLabel className="value">
                {supportedCustomerTypes
                  .filter((ct) => generalSettings.supportedCustomerTypes.includes(ct.value))
                  .map((ct) => ct.label)
                  .join(', ')}
              </DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Hide Limepay logo in terms page</DataLabel>
              <DataLabel className="value">{generalSettings.hideLimepayLogoInTermsPage ? 'Yes' : 'No'}</DataLabel>
            </div>
            <div className="col">
              <div className="col">
                <DataLabel className="label">Hide internal order Id from customer</DataLabel>
                <DataLabel className="value">
                  {generalSettings.hideInternalOrderIdFromCustomer ? 'Yes' : 'No'}
                </DataLabel>
              </div>
            </div>
          </MultiColRow>
          <MultiColRow>
            <div className="col">
              <DataLabel className="label">KYC limit without document</DataLabel>
              <DataLabel className="value">{generalSettings.kycLimitWithoutDocument}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">KYC limit with drivers licence</DataLabel>
              <DataLabel className="value">{generalSettings.kycLimitWithDriversLicence}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">KYC limit with passport</DataLabel>
              <DataLabel className="value">{generalSettings.kycLimitWithPassport}</DataLabel>
            </div>
          </MultiColRow>
          <MultiColRow>
            <div className="col">
              <DataLabel className="label">KYC limit customer links</DataLabel>
              <DataLabel className="value">{generalSettings.kycLimitCustomerLinks}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Display customer saved payment methods in checkout</DataLabel>
              <DataLabel className="value">
                {generalSettings.displayCustomerSavedPaymentMethodsInCheckout ? 'Yes' : 'No'}
              </DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Allow hide full pay</DataLabel>
              <DataLabel className="value">{generalSettings.allowHideFullPay ? 'Yes' : 'No'}</DataLabel>
            </div>
          </MultiColRow>
          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Classification</DataLabel>
              <DataLabel className="value">{generalSettings.classification}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">ID document requirement</DataLabel>
              <DataLabel className="value">{generalSettings.idDocRequirement ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Settlement type</DataLabel>
              <DataLabel className="value">{generalSettings.settlementType ?? '-'}</DataLabel>
            </div>
          </MultiColRow>
        </GeneralSettingsView>
      )}
    </>
  );
};

export default MarketplaceGeneralSettingsView;
